module.exports = __webpack_public_path__ + "img/game2.1dd9bc60.png";